// src/api/mgt1Api.js
import apiRequest from "../../../api/apiRequest";

export const mgt1Api = {
  // Fetch companies for dropdown
  fetchCompanies: (token) => {
    return apiRequest('/api/accounts', 'GET', token);
  },

    // NEW: Fetch MGT-1 register data
  fetchMgt1Register: (accountId, token) => {
    return apiRequest(`/api/register/mgt1?accountId=${accountId}`, 'GET', token);
  },
  
  // ── NEW: share-summary list ──────────────────────────────────
  // Response shape: [{ folioNo, memberName, jointHolderName, numberOfShares }, …]
  fetchMgt1ShareSummary: (accountId, token) => {
    return apiRequest(
      `/api/register/mgt1/share-summary?accountId=${accountId}`,
      "GET",
      token
    );
  },

  // ── NEW: add a share-holding row to a specific MGT-1 folio ──

  addNewShareHolding: (mgt1Id, payload, token) => {
    return apiRequest(
      `/api/register/mgt1/add-new/shareholding?mgt1Id=${mgt1Id}`,
      "POST",
      token,
      payload          // ← body is forwarded as-is to apiRequest
    );
  },
  

  // Submit MGT-1 form data
  submitMgt1Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mgt1?accountId=${accountId}`, 'POST', token, formData);
  },
};

export const mgt2Api = {
  // Fetch companies for dropdown
  fetchCompanies: (token) => {
    return apiRequest('/api/accounts', 'GET', token);
  },

  
    // NEW: Fetch MGT-1 register data
  fetchMgt2Register: (accountId, token) => {
    return apiRequest(`/api/register/mgt2?accountId=${accountId}`, 'GET', token);
  },
  
  // ── NEW: share-summary list ──────────────────────────────────
  // Response shape: [{ folioNo, memberName, jointHolderName, numberOfShares }, …]
  fetchMgt2ShareSummary: (accountId, token) => {
    return apiRequest(
      `/api/register/mgt2/share-summary?accountId=${accountId}`,
      "GET",
      token
    );
  },

  // ── NEW: add a share-holding row to a specific MGT-1 folio ──

  addNewDebentureHolding: (mgt2Id, payload, token) => {
    return apiRequest(
      `/api/register/mgt2/add-new/debenture-holding?mgt2Id=${mgt2Id}`,
      "POST",
      token,
      payload          // ← body is forwarded as-is to apiRequest
    );
  },

  // Submit MGT-2 form data
  submitMgt2Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mgt2?accountId=${accountId}`, 'POST', token, formData);
  },


};